var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('Transition',{attrs:{"appear":""}},[_c('FontAwesomeIcon',{class:_vm.$style.loadingIcon,attrs:{"icon":['fal', 'spinner-third'],"spin":""}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }